import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('api')

export const uploadTicketFile = (data: any, id: number, ticketId: string) => {
  return axiosInstance.put(`/tickets/${ticketId}/content/${id}/file`,data)
}

export const makeSeenTicket = (id:string) => {
  return axiosInstance.put(`/tickets/${id}/make-seen`, {})
}

export const closeTicket = (id:string) => {
  return axiosInstance.put(`/tickets/${id}/close`, {})
}